<template>
  <v-dialog
    persistent
    overlay-opacity="0.6"
    max-width="1024"
    max-height="400"
    :value="openDialog"
  >
    <!-- @input is required to emit emit input if clicked outside unless we use persistent -->
    <v-container fill-height fluid grid-list-xl>
      <v-layout justify-center wrap>
        <v-flex md12>
          <v-card class="pa-0 ">
            <v-toolbar color="primary" dark>
              <v-app-bar-nav-icon
                ><v-icon large>mdi-database-import</v-icon>
              </v-app-bar-nav-icon>
              <v-toolbar-title class="white--text"
                >Risultati importazione</v-toolbar-title
              >

              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon @click="closeDialog" large>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row class="text-left" align="start" justify="center">
                <v-col>
                  <base-material-stats-card
                    color="error"
                    icon="mdi-cellphone-erase"
                    :title="$t('scraper-import-result-duplicates')"
                    :value="results.duplicates"
                  />
                </v-col>

                <v-col>
                  <base-material-stats-card
                    color="success"
                    icon="mdi-cellphone-basic"
                    :title="$t('scraper-import-result-valid-mobiles')"
                    :value="results.valid_mobiles"
                  />
                </v-col>

                <v-col>
                  <base-material-stats-card
                    color="success"
                    icon="mdi-phone"
                    :title="$t('scraper-import-result-valid')"
                    :value="results.valid_fixed"
                  />
                </v-col>
              </v-row>
              <v-row class="text-left" align="start" justify="center">
                <v-col>
                  <base-material-stats-card
                    color="orange"
                    icon="mdi-layers-search-outline"
                    :title="$t('scraper-import-result-total-mobile')"
                    :value="results.mobiles_count"
                  />
                </v-col>

                <v-col>
                  <base-material-stats-card
                    color="orange"
                    icon="mdi-layers-search-outline"
                    :title="$t('scraper-import-result-total')"
                    :value="results.fixed_count"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogResolve: null,
      dialogReject: null,
      openDialog: false,
      results: {
        mobiles_count: "0",
        fixed_count: "0",
        duplicates: "0",
        valid_mobiles: "0",
        valid_fixed: "0",
      },
    };
  },

  methods: {
    show(results) {
      return new Promise((resolve, reject) => {
        this.dialogResolve = resolve;
        this.dialogReject = reject;
        this.openDialog = true;
        this.results = results;
        this.results.mobiles_count = this.results.mobiles_count.toString();
        this.results.fixed_count = this.results.fixed_count.toString();
        this.results.duplicates = this.results.duplicates.toString();
        this.results.valid_mobiles = this.results.valid_mobiles.toString();
        this.results.valid_fixed = this.results.valid_fixed.toString();
      });
    },

    hide() {
      this.openDialog = false;
      this.dialogReject();
    },

    confirm() {
      this.openDialog = false;
      this.dialogResolve();
    },

    dismiss() {
      this.hide();
    },

    closeDialog() {
      this.hide();
    },
  },
};
</script>
